import { render, staticRenderFns } from "./rule-modal.vue?vue&type=template&id=661aaf2a&scoped=true&"
import script from "./rule-modal.vue?vue&type=script&lang=js&"
export * from "./rule-modal.vue?vue&type=script&lang=js&"
import style0 from "./rule-modal.vue?vue&type=style&index=0&id=661aaf2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661aaf2a",
  null
  
)

export default component.exports